query AnalyticsSalesByCity($filter: AnalyticsSalesFilterInput!, $limit: Int) {
  analyticsSales(filter: $filter) {
    currency
    salesByCity(limit: $limit) {
      city
      sales
      revenue
    }
  }
}
